export interface CronPreset {
  label: string;
  value: string;
  cron: string;
}

export const CRON_PRESETS: CronPreset[] = [
  { label: "Every 6 hours", value: "every6h", cron: "0 */6 * * *" },
  { label: "Every 12 hours", value: "every12h", cron: "0 */12 * * *" },
];

export function buildDailyCron(hour: number): string {
  return `0 ${hour} * * *`;
}

export function cronToHuman(cron: string): string {
  if (!cron || cron.trim() === "") return "No schedule";

  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 5) return cron;

  const [minute, hour, dayOfMonth, month, dayOfWeek] = parts;

  if (minute === "0" && hour.startsWith("*/")) {
    const interval = hour.replace("*/", "");
    return `Every ${interval} hours`;
  }

  if (minute === "0" && /^\d+$/.test(hour) && dayOfMonth === "*" && month === "*" && dayOfWeek === "*") {
    const h = parseInt(hour, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    const displayHour = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return `Daily at ${displayHour}:00 ${ampm}`;
  }

  if (minute === "0" && /^\d+$/.test(hour) && dayOfMonth === "*" && month === "*" && /^[0-6]$/.test(dayOfWeek)) {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const h = parseInt(hour, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    const displayHour = h === 0 ? 12 : h > 12 ? h - 12 : h;
    return `${days[parseInt(dayOfWeek, 10)]}s at ${displayHour}:00 ${ampm}`;
  }

  return cron;
}

export function detectPreset(cron: string): { type: "every6h" | "every12h" | "daily" | "custom"; hour?: number } {
  if (!cron) return { type: "custom" };

  const parts = cron.trim().split(/\s+/);
  if (parts.length !== 5) return { type: "custom" };

  const [minute, hour, dayOfMonth, month, dayOfWeek] = parts;

  if (cron === "0 */6 * * *") return { type: "every6h" };
  if (cron === "0 */12 * * *") return { type: "every12h" };

  if (minute === "0" && /^\d+$/.test(hour) && dayOfMonth === "*" && month === "*" && dayOfWeek === "*") {
    return { type: "daily", hour: parseInt(hour, 10) };
  }

  return { type: "custom" };
}
